import React, { Component } from "react";
import Video from "./../Video/Video";
import { Docubytes } from "../../Model/Content"; //Include Home
/*import "./Docubytesplayer.css";
*/import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import BarLoader from "react-spinners/BarLoader";

export default class Docubytesplayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      VirsionCheckData: "",
      VirsionCheckDataloaded: false,
      SearchClick: false,
      NotificationClick: false
    };
  }

  componentDidMount() {

    Docubytes(0, 100).then((res) => {

      this.setState({
        items: res.data,
        DataisLoaded: true,
      });
    });

  }

  render() {

    if (this.state.DataisLoaded == false) {
      //  return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    }

    var data = this.state.items.message.contents;

    return (
      <div className="App">
        <center>
          <div className="video-container" id="video-container">

            {data.map((list, i) => {


              return (<Video
                key={i}
                channel={list.channel}
                song={list.song}
                url={list.url}
                likes={list.likes}
                comment={list.comment}
                shares={list.shares}
                Videodata={list}
              />)
            })}

          </div>
        </center>
        <Mobilemenu active="2" />
      </div>

    );
  }

}
